import { useState } from "react";
import { Menu } from "lucide-react";
import MenuOverlay from "./Menu";
import Logo from "/Logo.png";
import "./Navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        
        {/* Logo */}
        <div className="nav-logo">
          <a href="/" className="logo-link">
            <img src={Logo} alt="AI Squared Logo" className="header-logo" />
          </a>
        </div>

        <div className="nav-actions">
          {/* Login Button */}
          <a href="/dashboard/login" className="nav-login-btn">
            Dashboard Login
          </a>

          {/* Menu Icon */}
          <button className="menu-btn header-btn" onClick={() => setOpen(true)}>
            <Menu size={26} strokeWidth={1.5} />
          </button>
        </div>

      </nav>

      <MenuOverlay open={open} onClose={() => setOpen(false)} />
    </>
  );
}
